import { createStore } from 'botframework-webchat';
import { useEffect, useState } from 'react';
import { messageBackTranscriptMiddleware, preventAcknowledgementOfInitialActivitiesMiddleware, sessionMiddlewareFactory, webChatReadyStoreMiddleware } from '../storeMiddleware';
export const useWebChatStore = (webChatConfig, storeConfig) => {
    const [store, setStore] = useState([
        undefined,
        undefined
    ]);
    useEffect(() => {
        var _a;
        const webchatReadyMiddleware = webChatReadyStoreMiddleware(() => storeConfig.onDirectLineConnected());
        let destroyStore;
        if (webChatConfig) {
            const middleware = [
                ...((_a = storeConfig.middleware) !== null && _a !== void 0 ? _a : []),
                preventAcknowledgementOfInitialActivitiesMiddleware,
                messageBackTranscriptMiddleware,
                webchatReadyMiddleware
            ];
            if (webChatConfig.session) {
                const sessionMiddleware = sessionMiddlewareFactory(webChatConfig.session);
                if (sessionMiddleware) {
                    sessionMiddleware.onActivity(() => storeConfig.onSessionActivity());
                    sessionMiddleware.onExpired(() => {
                        sessionMiddleware.destroy();
                        storeConfig.onSessionExpired();
                    });
                    middleware.push(sessionMiddleware.middleware);
                    destroyStore = sessionMiddleware.destroy;
                }
            }
            const store = createStore({}, ...middleware);
            setStore([store, destroyStore]);
            return destroyStore;
        }
    }, [webChatConfig, setStore]);
    return store;
};
//# sourceMappingURL=useWebChatStore.js.map